var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import EventEmitter from './event-emitter';
var i18n = {
    AFFECT: 'This will affect <strong><span data-total="">12.500</span> entries</strong>'
};
var BulkEditModal = /** @class */ (function (_super) {
    __extends(BulkEditModal, _super);
    function BulkEditModal(el, Editable) {
        var _this = _super.call(this, el) || this;
        _this.canDismiss = true;
        _this.Editable = Editable;
        _this.Events = new EventEmitter();
        _this.hideProcess();
        _this.setEditable(_this.Editable.get());
        return _this;
    }
    BulkEditModal.prototype.close = function () {
        if (!this.canDismiss) {
            return;
        }
        _super.prototype.close.call(this);
        this.Events.emit('close');
    };
    BulkEditModal.prototype.setTotal = function (number) {
        this.el.querySelectorAll('[data-total] ').forEach(function (el) {
            el.innerHTML = number;
        });
    };
    BulkEditModal.prototype.setEditable = function (el) {
        this.Editable = el;
        this.el.querySelector('[data-editable]').append(el);
    };
    BulkEditModal.prototype.setTitle = function (title) {
        this.el.querySelector('[data-title]').innerHTML = title;
    };
    BulkEditModal.prototype.setProcess = function (el) {
        var container = this.el.querySelector('[data-process]');
        this.el.querySelector('.ac-modal__dialog__content.-info').style.display = 'none';
        container.innerHTML = '';
        container.append(el);
        container.style.display = 'block';
        this.canDismiss = false;
        this.toggleCloseButton(false);
    };
    BulkEditModal.prototype.setCanDismiss = function (candismiss) {
        this.canDismiss = candismiss;
    };
    BulkEditModal.prototype.toggleCloseButton = function (show) {
        if (show) {
            this.el.querySelector('.ac-modal__dialog__close').style.display = 'block';
        }
        else {
            this.el.querySelector('.ac-modal__dialog__close').style.display = 'none';
        }
    };
    BulkEditModal.prototype.hideProcess = function () {
        this.el.querySelector('[data-process]').style.display = 'none';
    };
    BulkEditModal.appendMarkup = function () {
        var modal = document.createElement('div');
        modal.classList.add('ac-modal');
        modal.classList.add('-bulkedit');
        modal.innerHTML = "\n\t\t\t\t<div class=\"ac-modal__dialog\">\n\t\t\t\t\t<div class=\"ac-modal__dialog__header\">\n\t\t\t\t\t\t<span data-title></span>\n\t\t\t\t\t\t<button class=\"ac-modal__dialog__close\">\n\t\t\t\t\t\t\t<span class=\"dashicons dashicons-no\"></span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"ac-modal__dialog__content -editable\" data-editable></div>\n\t\t\t\t\t<div class=\"ac-modal__dialog__content -info\">\n\t\t\t\t\t\t<span class=\"acp-be-warning__icon dashicons dashicons-info\"></span><em>" + i18n.AFFECT + "</em> \n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"ac-modal__dialog__content -process\" data-process>\n\t\t\t\t\t\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t";
        document.body.appendChild(modal);
        return modal;
    };
    return BulkEditModal;
}(AdminColumns.Modals.defaults.modal));
AdminColumns.Editing.BulkEdit.Modal = BulkEditModal;
